export default {
  List: {
    Title: "Báo cáo",
    SearchPlaceHolder: "Tìm kiếm báo cáo",
    EditButton: "Sắp xếp, ẩn hiện",
    CancelButton: "Hủy",
    SaveButton: "Lưu",
    ObjectName: "Báo cáo",
    ExportSum: "Tổng",
  },
  ReportName: {
    EmployeeAssetDetail: "Báo cáo chi tiết quá trình sử dụng tài sản",
    AssetTypeByJoposition: "Danh sách tài sản cấp phát theo yêu cầu vị trí công việc",
    AssetDetailByEmployee: "Báo cáo chi tiết tài sản theo nhân viên",
    AssetExpiryDate: "Báo cáo thời hạn bảo hành của tài sản",
    ListAssetIssueEmployee: "Danh sách tài sản cấp phát cho nhân viên",
    AssetDetailByProvider: "Danh sách tài sản theo nhà cung cấp",
    ListAssetFollowOrganizationUnit: "Danh sách tài sản theo phòng ban",
    StatusUseAsset: "Thống kê tài sản theo tình trạng",
    AssetBroken: "Danh sách tài sản mất, hỏng",
    RepairAssetCost: "Báo cáo chi phí sửa chữa, bảo dưỡng tài sản",
    AssetIncreaseAndReduction: "Báo cáo tình hình tăng, giảm tài sản",
    AssetBarCode: "Mã vạch",
    StatisticalAssetByUseOrganizationUnit: "Thống kê tài sản theo đơn vị sử dụng",
    StatisticalAssetByAssetCategoryAndType: "Thống kê tài sản theo nhóm/ loại tài sản",
    StatisticalAssetByUnit: "Thống kê tài sản theo đơn vị",
    QuantityByStatusAsset: "Thống kê số lượng tài sản theo tình trạng",
    AssetByLocation: "Thống kê tài sản theo vị trí",
    StatisticalAssetByManegementUnit: "Thống kê tài sản theo đơn vị quản lý",
    StatisticalAssetByOrgUnit: "Thống kê tài sản theo đơn vị sử dụng",
    AssetRepairCostsFluctuation: "Thống kê chi phí sửa chữa tài sản",
  },
  Template: {
    Title: "Tùy chỉnh",
    CancelButton: "Hủy bỏ",
    SaveButton: "Áp dụng",
    SaveNewButton: "Lưu thành báo cáo mới",
    ColumnField: "Tên cột dữ liệu",
    ColumnCaption: "Tên cột hiển thị",
    ColumnGroup: "Nhóm cột",
    ColumnLock: "Cố định cột",
    SearchPlaceHolder: "Tìm kiếm",
    GroupBy: "Gom nhóm theo",
    EnterName: {
      Title: "Lưu báo cáo",
      Name: "Tên báo cáo",
    },
  },
  ReportViewer: {
    Print: "In",
    Export: "Xuất file",
    ExportExcel: "Xuất Excel",
    ExportPdf: "Xuất PDF",
    ExportWord: "Xuất Word",
  },
  SearchPlaceHolder: "Nhập từ khóa tìm kiếm",
  ToDate: "Đến ngày",
  Time: "Thời gian",
  ManagementUnit: "Đơn vị quản lý",
  OrganizationUnit: "Đơn vị công tác",
  ManagementUnitAsset: "Đơn vị quản lý tài sản",
  AssetStatus: "Tình trạng",
  ManagementUnitUseAsset: "Đơn vị sử dụng",
  AssetType: "Loại tài sản",
  SearchButton: "Lấy dữ liệu",
  ReportTerm: "tháng {0} năm {1}",
  ReportTermRange: "từ tháng {0} đến tháng {1} năm {2}",
  notEmptyBothAssetCategoryAndAssetType:
    "Không được để trống đồng thời nhóm tài sản và loại tài sản",
  RequiredGroupAssetStatus: "Tình trạng không được bỏ trống",
  RequiredUnitType: "Thống kê theo không được bỏ trống",
  QuantityByStatusAsset: {
    SearchPlaceholder: "Nhập tình trạng tài sản để tìm kiếm",
  },
  PeriodType: "Thống kê theo",
  FromMonth: "Từ tháng",
  ToMonth: "Đến tháng",
  FromYear: "Từ năm",
  ToYear: "Đến năm",
  Year: "Năm",
  ReportYearTerm: "Từ năm {0} đến năm {1}",
};
